import {FETCH_USAGE_HISTORY_DATA} from '../../dataFetchers/usageDataFetcher';

const usageHistoryReducer = (state = {
  seriesData: null
}, action) => {
  switch (action.type) {
    case FETCH_USAGE_HISTORY_DATA.FETCH_USAGE_HISTORY_DATA:
      state = {
        ...state,
        seriesData: action.payload,
        error: false
      }
      break;
    case FETCH_USAGE_HISTORY_DATA.FETCH_USAGE_HISTORY_DATA_FAILED:  
      state = {
        ...state,
        seriesData: [],
        error: true
      }
      break;
    default: 
      break;
  }
  return state;
}

export default usageHistoryReducer;
